import { MutationTree } from 'vuex';

import { TimeSyncState } from './types';

export const mutations: MutationTree<TimeSyncState> = {
  setOffset(state: TimeSyncState, offset: number) {
    state.offset = offset;
  }
};
